import {
  CustomerDeactivationModalKey,
  CustomerDetailsKey,
  CustomerListPageKey,
  CustomerListTableKey,
  CustomerPendingListTableKey,
  CustomerUploadModalKey
} from '../../TModules';

export const translations = {
  [CustomerListTableKey]: {
    Identifier: 'Kennung',
    Name: 'Name',
    Status: 'Status',
    DateJoined: 'Beitrittsdatum',
    Actions: 'Aktionen',
    SearchCustomers: 'Kunden suchen',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Initial: 'Initial'
  },
  [CustomerUploadModalKey]: {
    HandleUpload: {
      SuccessMessage: 'Datei hochgeladen',
      ErrorMessage: 'Fehler beim Hochladen der Datei.',
      Title: 'Kundendatei hochladen',
      OkText: 'Hochladen',
      CancelText: 'Abbrechen',
      UploadButton: 'Hochladen',
      UploadDraggerMessage:
        'Klicken oder ziehen Sie die Datei in diesen Bereich, um sie hochzuladen',
      DownloadSample: 'Beispiel herunterladen',
      AcceptedFormat: 'Akzeptiertes Format: Nur .txt., .xlsx- oder .csv-Dateien'
    }
  },
  [CustomerPendingListTableKey]: {
    RequestId: 'Anfrage-ID',
    Customer: 'Kunde',
    RequestType: 'Anfragetyp',
    Status: 'Status',
    Comment: 'Kommentar',
    LastUpdated: 'Zuletzt aktualisiert',
    DateOfExpiry: 'Ablaufdatum',
    Actions: 'Aktionen',
    Comments: 'Kommentare',
    ViewDetails: 'Details anzeigen',
    Approve: 'Genehmigen',
    ApproveRequests: 'Anfragen genehmigen',
    CustomerStampView: 'Kundenstempelansicht',
    LoyaltyProgramDetails: 'Treueprogramm-Details',
    CustomerGameView: 'Kundenspielansicht',
    CustomerRewardView: 'Kundenbelohnungsansicht',
    ApproveSelectedButton: 'Ausgewählte genehmigen',
    ApproveMultipleMessageModal: {
      SuccessMessage: 'Uploads genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Datei.',
      Title: 'Mehrere Anfragen genehmigen?',
      OkText: 'Ausgewählte genehmigen',
      DescriptionText: `
      Möchten Sie wirklich alle ausgewählten Anfragen genehmigen?
      <br />
      Bitte überprüfen Sie die Details, bevor Sie genehmigen, da diese Aktion nicht rückgängig gemacht werden kann.`
    },
    ApproveRequestModal: {
      SuccessMessage: 'Anfrage wurde genehmigt',
      FailureMessage: 'Fehler beim Genehmigen der Anfrage.',
      Title: 'Anfrage genehmigen?',
      OkText: 'Genehmigen',
      DescriptionText: `Möchten Sie diese Anfrage wirklich genehmigen?`
    },
    UploadCommentModal: {
      ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
      Content: 'Inhalt',
      DeleteButton: 'Löschen Taste',
      Time: 'Zeit',
      ErrorAddingComment: 'Fehler beim Hinzufügen des Kommentars',
      CommentAdded: 'Kommentar hinzugefügt',
      EnterYourCommentHere: 'Geben Sie hier Ihren Kommentar ein',
      AddComment: 'Kommentar hinzufügen',
      CommentsAdded: 'Kommentare hinzugefügt',
      Delete: 'Löschen'
    },
    DeleteCommentModal: {
      CommentDeleted: 'Kommentar gelöscht',
      ErrorDeletingComment: 'Fehler beim Löschen des Kommentars',
      DeleteComment: 'Kommentar löschen?',
      Delete: 'Löschen',
      Description: `
      Möchten Sie Ihren Kommentar wirklich löschen?
      <br />
      Diese Aktion kann nicht rückgängig gemacht werden.
      `
    }
  },
  [CustomerListPageKey]: {
    PendingRequests: 'Ausstehende Anfragen',
    Customers: 'Kunden',
    CustomersList: 'Kundenliste',
    Upload: 'Hochladen',
    TransactionRequests: 'Transaktionsanfragen'
  },
  [CustomerDeactivationModalKey]: {
    ProvideReasonForDeactivation: 'Grund für Deaktivierung angeben',
    ProvideReasonForActivation: 'Grund für Aktivierung angeben',
    Deactivate: 'Deaktivieren',
    Activate: 'Aktivieren',
    Cancel: 'Abbrechen',
    DeactivationReason: 'Bitte Grund auswählen'
  },
  [CustomerDetailsKey]: {
    ID: 'ID',
    CustomerDetails: 'Kundendetails',
    Identifier: 'Kennung',
    UserInfo: 'Benutzerinformationen',
    FirstName: 'Vorname',
    MiddleName: 'Zweiter Vorname',
    LastName: 'Nachname',
    Gender: 'Geschlecht',
    Address: 'Adresse',
    Birthday: 'Geburtstag',
    JoinedAt: 'Beigetreten am',
    CreatedVia: 'Erstellt über',
    ReferralCode: 'Empfehlungscode',
    Email: 'E-Mail',
    Phone: 'Telefon',
    State: 'Bundesland',
    City: 'Stadt',
    Race: 'Rasse',
    Segment: 'Segment',
    AccountId: 'Konto-ID',
    Nationality: 'Nationalität',
    AlternateId: 'Alternative ID',
    ProductType: 'Produkttyp',
    Classification: 'Klassifikation',
    LocationState: 'Standort Bundesland',
    PreferredLanguage: 'Bevorzugte Sprache',
    FindRewardByNameTypeOrMerchant: 'Belohnung nach Name, Typ oder Händler finden',
    IssueRewards: 'Belohnungen ausstellen',
    ErrorRetrievingCustomer: 'Fehler beim Abrufen des Kunden',
    CustomerRewards: 'Kundenbelohnungen',
    LoyaltyProgram: 'Treueprogramm',
    AccountDetails: 'Kontodetails',
    Campaigns: 'Kampagnen',
    RewardsLabel: 'Prämien',
    Engagement: 'Engagement',
    CustomerIDNotFound: 'Kunden-ID nicht gefunden',
    DeleteUser: 'Benutzer löschen',
    Activate: 'Aktivieren',
    Deactivate: 'Deaktivieren',
    ACTIVE: 'AKTIV',
    Inactive: 'Inaktiv',
    DeactivationReason: 'Deaktivierungsgrund',

    Name: 'Name',
    Status: 'Status',
    Tenure: 'Amtszeit',
    Tier: 'Stufe',
    Balance: 'Guthaben',
    ToNextTier: 'Zur nächsten Stufe',
    MembershipExpiry: 'Mitgliedschaftsablauf',

    Rewards: {
      FindRewardByNameTypeOrMerchant: 'Belohnung nach Name, Typ oder Händler finden',
      IssueRewardsManually: 'Belohnungen manuell ausstellen',
      Issued: 'Ausgestellt',
      Pending: 'Ausstehend',
      GiftedAway: 'Verschenkt',
      Redeemed: 'Eingelöst',
      RedemptionInProgress: 'Einlösung in Bearbeitung',
      FullyRedeemed: 'Vollständig eingelöst',
      Voided: 'Ungültig gemacht',
      Expired: 'Abgelaufen',
      Archived: 'Archiviert',

      Name: 'Name',
      DeletionRequested: 'Löschung angefordert',
      ID: 'ID',
      Merchant: 'Händler',
      DateOfIssued: 'Ausstellungsdatum',
      ValidFrom: 'Gültig von',
      ValidTo: 'Gültig bis',
      VoucherCode: 'Gutscheincode',
      AdminFee: 'Verwaltungsgebühr',
      Action: 'Aktion',
      DateOfExpired: 'Ablaufdatum',
      DateOfGifted: 'Geschenkdatum',
      DateOfRedeemed: 'Einlösedatum',
      RequestId: 'Anfrage-ID',
      Status: 'Status',
      RewardId: 'Belohnungs-ID',
      IssuedOn: 'Ausgestellt am',

      VoidVoucher: 'Gutschein ungültig machen',
      ChangeExpiryDate: 'Ablaufdatum ändern',
      AmendReward: 'Belohnung ändern',
      UndoRedeem: 'Einlösung rückgängig machen',
      ThereIsNoActionForGiftedVoucher: 'Keine Aktion für verschenkten Gutschein.',
      RevertBackToIssued: 'Zu Ausgestellt zurückkehren',
      WaiveAdminFee: 'Verwaltungsgebühr erlassen',
      DeleteReward: 'Belohnung löschen',
      ViewComments: 'Kommentare anzeigen',
      ApproveIssue: 'Ausgabe genehmigen',

      ViewAndAddComments: 'Kommentare anzeigen und hinzufügen',
      RequestHasBeenApproved: 'Anfrage wurde genehmigt',
      SomethingWentWrong: 'Etwas ist schief gelaufen',
      HandleUndoRedeemErrorMessage:
        'Einlösung kann nicht rückgängig gemacht werden - bitte ändern Sie das Ablaufdatum und versuchen Sie es erneut.',
      HandleUndoRedeemConfirmModalTitle: 'Bestätigen',
      HandleUndoRedeemConfirmModalMessage:
        'Dies wird den Gutscheinzustand auf Ausgestellt zurücksetzen - fortfahren?',

      HandleVoidVoucherMakerCheckerSuccessMessage:
        'Ungültigmachungsantrag zur Genehmigung eingereicht',
      HandleVoidVoucherSuccessMessage: 'Gutschein ist ungültig gemacht',
      HandleVoidVoucherConfirmModalMakerCheckerRightButtonText: 'Ungültigmachung beantragen',
      HandleVoidVoucherConfirmModalRightButtonText: 'Bestätigen',
      HandleVoidVoucherConfirmModalMakerCheckerTitle: 'Ungültigmachungsantrag einreichen?',
      HandleVoidVoucherConfirmModalTitle: 'Bestätigen',
      HandleVoidVoucherConfirmModalMakerCheckerMessage:
        'Sind Sie sicher, dass Sie die Ungültigmachung des Belohnungsgutscheins beantragen möchten? Einmal genehmigt, können Sie ihn nicht wiederherstellen.',
      HandleVoidVoucherConfirmModalMessage:
        'Dies wird den Belohnungsgutschein ungültig machen - fortfahren?',

      HandleRevertRedemptionToIssuedConfirmModalTitle: 'Bestätigen',
      HandleRevertRedemptionToIssuedMessageConfirmModalMessage:
        'Dies wird den Gutscheinzustand auf Ausgestellt zurücksetzen - fortfahren?',

      ShowOCBCDemoConfirmModalTitle: 'Bestätigen',
      ShowOCBCDemoConfirmModalMessage: 'Dies wird die Verwaltungsgebühr erlassen - fortfahren?'
    },

    IssueRewardsModal: {
      Title: 'Belohnungen manuell ausstellen',
      OkText_one: '{{count}} Belohnung ausstellen',
      OkText_other: '{{count}} Belohnungen ausstellen',
      SearchPlaceholder: 'Belohnung nach Name, Typ oder Händler finden',
      ActiveTabLabel: 'Aktiv',
      PrivateTabLabel: 'Privat'
    },
    IssueRewardsTable: {
      Name: 'Name',
      Merchant: 'Händler',
      ValidityPeriod: 'Gültigkeitszeitraum',
      Balance: 'Guthaben'
    },
    AuditLog: {
      Title: 'Audit-Protokoll',
      LastUpdatedAt: 'Zuletzt aktualisiert am',
      IpAddress: 'IP-Adresse',
      User: 'Benutzer',
      Action: 'Aktion',
      Description: 'Beschreibung',
      RenderSummaryIsCreated: 'erstellt',
      RenderSummaryIsUpdated: 'aktualisiert',
      Details: 'Details',
      Old: 'Alt',
      New: 'Neu',
      Audience: {
        Created: 'Audience created',
        NameUpdated: 'Audience name updated',
        FiltersUpdated: 'Filter customers updated',
        FileUploaded: 'Audience File uploaded',
        FileRemoved: 'Audience File removed',
        FileRelationChanged: 'Audience File relation changed',
        Uploaded: 'uploaded',
        Removed: 'removed',
        RelationChangedTo: 'relation changed to',
        NameLabel: 'Audience name',
        Criteria: {
          Age: 'Age',
          Gender: 'Gender',
          CustomAttributes: 'Custom Attributes'
        },
        AttributeGroup: 'Customer attributes',
        AttributeGroupRaw: 'Customer attributes (excluded group)'
      },
      DetailsColumn: {
        AutoFillStamps: 'Briefmarken automatisch ausfüllen',
        Wedges: 'Keile',
        LandingPage: 'Zielseite',
        EnrolmentType: 'Anmeldungsart',
        AutoEnrolUsers: 'Automatische Benutzeranmeldung',
        State: 'Status',
        NameEn: 'Name (EN)',
        Ordering: 'Sortierung',
        Timezone: 'Zeitzone',
        StartDate: 'Startdatum',
        AutoIssueMoves: 'Automatische Zugausgabe',
        TypeOfCampaign: 'Kampagnentyp',
        OutcomesPerMove: 'Ergebnisse pro Zug',
        TypeOfCampaignReferral: 'Kampagnen-Empfehlungstyp',
        Rewards: 'Belohnungen',
        PeriodUnits: 'Zeiteinheiten',
        RewardsOrdering: 'Belohnungssortierung',
        NoOfStampsPerColumn: 'Briefmarken pro Spalte',
        CampaignIntervalPeriod: 'Kampagnen-Intervall',
        DisplayPropertiesZhHans: 'Anzeige-Eigenschaften Zh Hans',
        DisplayPropertiesZhHant: 'Anzeige-Eigenschaften Zh Hant',

        Header: 'Header',
        CardImage: 'Kartenbild',
        ButtonText: 'Schaltflächentext',
        ThumbnailImage: 'Vorschaubild',
        ButtonBgColour: 'Schaltflächentextfarbe',
        GiftActiveImage: 'Geschenkbild aktiv',
        ButtonTextColour: 'Schaltflächentextfarbe',
        StampActiveImage: 'Briefmarke aktiv',
        DisplayCampaignAs: 'Kampagne als anzeigen',
        GiftInactiveImage: 'Geschenkbild inaktiv',
        ButtonExternalLink: 'Schaltflächentext-Link',
        StampInactiveImage: 'Briefmarke inaktiv',
        CardBackgroundImage: 'Kartenhintergrundbild',
        Cols: 'Spalten',
        Rows: 'Zeilen',
        Tags: 'Tags',
        Labels: 'Labels',
        Referee: 'Referee',
        Categories: 'Kategorien',
        DescriptionEn: 'Beschreibung EN',
        TermsAndConditionsEn: 'Nutzungsbedingungen EN',
        RefereeTotalRewardLimit: 'Referee-Gesamtguthabenlimit',
        ClaimPrize: 'Belohnung beanspruchen',
        StampsAwarded: 'Briefmarken vergeben',
        Status: 'Status',
        Value: 'Wert',
        Operators: 'Operatoren',
        RuleName: 'Regelname',
        Body: 'Körper',
        MilestonesSuccessImage: 'Milestone-Erfolgsbild',
        SelectRuleAttribute: 'Regelattribut auswählen',
        EndDate: 'Enddatum',
        GrandPrizeOutcome: 'Hauptgewinnausgang',
        RaffleTicketOutcome: 'Raffle-Ticketausgang',
        NoOfStampsPerRow: 'Briefmarken pro Zeile',
        TotalStampsOnCard: 'Briefmarken insgesamt'
      }
    },
    DeleteCustomerModal: {
      Title: 'Benutzer löschen?',
      OkText: 'bestätigen',
      CancelText: 'Zurückgehen',
      DescriptionLineOne: 'Möchten Sie diesen Benutzer wirklich löschen?',
      DescriptionLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      Name: 'Name:',
      Identifier: 'Kennung:'
    },

    LoyaltyProgramsTable: {
      Name: 'Name',
      Status: 'Status',
      Tenure: 'Amtszeit',
      Tier: 'Stufe',
      Balance: 'Guthaben',
      ToNextTier: 'Zur nächsten Stufe',
      MembershipExpiry: 'Mitgliedschaftsablauf',
      Actions: 'Aktionen'
    },
    LoyaltyProgramDetailsModal: {
      Title: 'Treueprogramm-Details',
      CloseButton: 'SCHLIESSEN',
      Active: 'Aktiv',
      Pending: 'Ausstehend',
      Actions: 'Aktionen',
      ActionCancelRequest: 'Anfrage stornieren',
      ActionApproveIssue: 'Ausgabe genehmigen',
      ActionApproveDeletion: 'Löschung genehmigen',
      ActionDenyDeletion: 'Löschung ablehnen',
      ActionComments: 'Kommentare',
      ActionCommentsModalTitle: 'Kommentare anzeigen und hinzufügen',

      Event: 'Ereignis',
      EventButton: 'Löschung angefordert',
      Status: 'Status',
      SubmissionDate: 'Einreichungsdatum',
      Points: 'Punkte',
      ExpiresAt: 'Läuft ab am',
      TransactionId: 'Transaktions-ID',
      LoyaltyTransactionId: 'Treuetransaktions-ID',
      AmountTransacted: 'Transaktionsbetrag',
      TransactionAmount: 'Transaktionsbetrag',
      TransactionDate: 'Transaktionsdatum',
      Date: 'Datum',
      TransactionRef: 'Transaktionsreferenz',
      AwardingTransactionId: 'Vergabe-Transaktions-ID',
      Properties: 'Eigenschaften',
      Merchant: 'Händler',
      GlAccountNumber: 'GL-Kontonummer',
      CostCenterId: 'Kostenstellen-ID',
      BranchCode: 'Filialcode',

      ChangeStatus: 'Status ändern',
      ChangeTier: 'Stufe ändern',
      AddOrRemovePoints: 'Punkte hinzufügen / entfernen',

      ChangeStatusForm: {
        Active: 'Aktiv',
        Inactive: 'Inaktiv',
        Save: 'Speichern'
      },
      ChangeTierForm: {
        Label: 'Stufe überschreiben läuft ab am:',
        Save: 'Speichern'
      },
      PointsForm: {
        SelectGlAccount: 'GL-Konto auswählen',
        GlAccountType: 'GL-Kontotyp',
        GlAccountName: 'GL-Kontoname',
        Message: 'Schreiben Sie eine Nachricht zu dieser Punkteanpassung.',
        AdjustPointsButton: 'Punkte anpassen'
      },
      UpdateLoyaltyProgramCustomerStateSuccessMessage: 'Status aktualisiert',
      UpdateLoyaltyProgramCustomerStateErrorMessage: 'etwas ist schief gelaufen',
      UpdateLoyaltyProgramCustomerTierSuccessMessage: 'Stufe aktualisiert',
      UpdateLoyaltyProgramCustomerTierErrorMessage: 'etwas ist schief gelaufen',
      CreateCustomerLoyaltyTransaction: {
        GLAccountTypeRequiredMessage: 'GL-Kontotyp ist erforderlich',
        GlAccountNameRequiredMessage: 'GL-Kontoname ist erforderlich',
        MakerCheckerSuccessMessage: 'Punktausgabe-Antrag zur Genehmigung eingereicht',
        SuccessMessage: 'Transaktion hinzugefügt',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerRequestLoyaltyTransaction: {
        SuccessMessage: 'Anfrage wurde storniert',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      ApproveDenyCustomerRequestLoyaltyTransaction: {
        ApproveSuccessMessage: 'Anfrage wurde ',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerLoyaltyTransaction: {
        MakerCheckerSuccessMessage: 'Transaktionslöschungsantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Transaktion gelöscht',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      RecoverCustomerLoyaltyTransaction: {
        SuccessMessage: 'Transaktion wiederhergestellt',
        ErrorMessage: 'etwas ist schief gelaufen'
      },
      DeleteCustomerLoyaltyTransactionModal: {
        ActiveTitle: 'Löschungsantrag einreichen?',
        Title: 'Anfrage stornieren?',
        ActiveOkText: 'Löschung beantragen',
        OkText: 'Anfrage stornieren',
        ActiveCancelText: 'Abbrechen',
        CancelText: 'Zurück',
        ActiveMessage:
          'Sind Sie sicher, dass Sie die Löschung dieser Punkte beantragen möchten? Einmal genehmigt, können Sie sie nicht wiederherstellen.',
        MessageLineOne: `Die Ausgabe dieser Punkte steht noch zur Genehmigung aus. Möchten Sie die Anfrage wirklich stornieren?`,
        MessageLineTwo: 'Diese Aktion kann nicht rückgängig gemacht werden.'
      },
      ApproveDenyModal: {
        ApproveIssueTitle: 'Belohnungsausgabe genehmigen',
        ApproveDeletionTitle: 'Belohnungslöschung genehmigen',
        DenyDeletionTitle: 'Belohnungslöschung ablehnen',
        DenyDeletionOkText: 'Ablehnen',
        OkText: 'Genehmigen',
        ApproveIssueAndDeletionMessageLineOne: 'Sind Sie sicher, dass Sie die',
        ApproveIssueAndDeletionMessageLineTwo:
          'dieser Belohnung genehmigen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        Message: ` Sind Sie sicher, dass Sie die Löschung dieser Belohnung ablehnen möchten? Diese Aktion kann nicht
                    rückgängig gemacht werden, und die Belohnung bleibt im ausstehenden Zustand, bis sie genehmigt wird.`
      },

      LineProgressBar: {
        HeaderDateText: 'Beginn des Zeitraums',
        CustomerTierText: 'Der Benutzer befindet sich derzeit in',
        Tier: 'Stufe',
        CustomerForcedMinimumTierText: 'Der Benutzer wurde in die Mindeststufe gezwungen',
        CustomerForcedMaximumTierText: `Der Benutzer wurde `,
        FORCED: 'GEZWUNGEN',
        into: 'in',
        EndOfPeriod: 'Ende des Zeitraums',
        ForcedTier: 'Erzwungene Stufe',
        ForcedMinTier: 'Erzwungene Mindeststufe',
        UserHasBeen: 'Benutzer wurde',
        Forced: 'gezwungen',
        To: 'zu',
        Status: 'Status',
        Until: 'bis',
        DeleteForcedTierLinkText: 'X Erzwungene Stufe deaktivieren',
        ToMinimum: 'auf Minimum',
        TheUserHasEarned: 'Der Benutzer hat verdient',
        Points: 'Punkt(e)',
        DuringThisCycle: 'während dieses Zyklus.',
        TheUserRequires: 'Der Benutzer benötigt',
        ToLevelUpTo: 'um aufzusteigen zu',
        TheUserHas: 'Der Benutzer hat',
        Available: 'verfügbar.'
      }
    },

    CustomerCampaigns: {
      ID: 'ID',
      HitThePinata: 'Auf die Piñata schlagen',
      ScratchCard: 'Rubbellos',
      Plinko: 'Plinko',
      Name: 'Name',
      CampaignType: 'Kampagnentyp',
      Status: 'Status',
      StartDate: 'Startdatum',
      EndDate: 'Enddatum',
      Actions: 'Aktionen',
      SearchCampaignsPlaceholder: 'Kampagnen suchen',
      UnenrollCustomer: 'Kunden abmelden',
      NotStarted: 'Nicht gestartet',
      Active: 'Aktiv',
      Completed: 'Abgeschlossen',
      NotCompleted: 'Nicht abgeschlossen',
      Enrollable: 'Einschreibbar',
      EndedAndNotEnrolled: 'Beendet und nicht eingeschrieben',
      Enrolled: 'Eingeschrieben',
      NotEnrolled: 'Nicht eingeschrieben',
      SpinTheWheel: 'Drehen Sie das Rad',
      ShakeTheTree: 'Den Baum schütteln',
      EnrollCustomer: 'Kunden einschreiben',
      SelectCampaignsPlaceholder: 'Kampagnen auswählen',

      SelectedTypeCampaigns: {
        Customers: 'Kunden',
        Campaigns: 'Kampagnen',
        StampCampaign: 'Stempelkampagne',
        QuizCampaign: 'Quizkampagne',
        SurveyCampaign: 'Umfragekampagne',
        GameCampaign: 'Spielkampagne',
        ProgressCampaign: 'Fortschrittskampagne',
        QuestCampaign: 'Questkampagne',
        InstantRewardCampaign: 'Sofortbelohnungskampagne',
        StreakCampaign: 'Streak-Kampagne',
        CampaignProgress: 'Dieser Kunde befindet sich derzeit in'
      },

      RaffleView: {
        TriggerName: 'Auslösername',
        RaffleRuleID: 'Raffleregel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionRuleID: 'Transaktionsregel-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit',
        RaffleCode: 'Rafflec-Code',
        State: 'Status'
      },

      InstantRewardView: {
        TriggerName: 'Auslösername',
        RuleID: 'Regel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit'
      },

      QuestView: {
        TriggerName: 'Auslösername',
        Task: 'Aufgabe',
        QuestRuleID: 'Quest-Regel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionRuleID: 'Transaktionsregel-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit',
        State: 'Status',
        Actions: 'Aktionen',
        MarkCompleted: 'Als abgeschlossen markieren',
        MarkCompletedSuccessMessage: 'Punkte erfolgreich aktualisiert!',
        MarkCompletedErrorMessage: 'Fehler beim Aktualisieren der Punkte'
      },

      CustomerProgressCard: {
        TriggerName: 'Auslösername',
        ProgressRuleID: 'Fortschrittsregel-ID',
        TransactionDetails: 'Transaktionsdetails',
        TransactionID: 'Transaktions-ID',
        TriggeredDateOrTime: 'Ausgelöstes Datum / Uhrzeit',
        Points: 'Punkte'
      },

      CustomerGameView: {
        TriesID: 'Versuche-ID',
        Status: 'Status',
        AcquiredVia: 'Erworben über',
        ReasonCode: 'Begründungscode',
        Email: 'E-Mail',
        ID: 'ID',
        DateOfIssue: 'Ausstellungsdatum',
        DateOfExpiry: 'Ablaufdatum',
        Outcomes: 'Ergebnisse',
        VoucherID: 'Gutschein-ID',
        NoOutcome: 'kein Ergebnis',
        SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen!'
      },

      CustomerQuizAndSurveyView: {
        QuestionNo: 'Fragen-Nr.',
        Question: 'Frage',
        Response: 'Antwort',
        SubmissionDateOrTime: 'Einreichungsdatum / -uhrzeit',
        Result: 'Ergebnis'
      },

      IssueGameChangeModal: {
        MakerCheckerSuccessMessage: 'Spielchance-Ausgabeantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Spielchancen erfolgreich ausgestellt!',
        ErrorMessage: 'Fehler beim Ausstellen der Spielchancen',
        IssueGameTriesButton: 'Spielversuche ausstellen',
        Title: 'Spielchance ausstellen an',
        OkText: 'Chance ausstellen',
        HowManyChances: 'Wie viele Chancen?',
        ReasonForIssuance: 'Grund für die Ausstellung'
      },

      CustomerStampCards: {
        CardHash: 'Karte #',
        StampCardID: 'Stempelkarte-ID',
        State: 'Status',
        ExpiryDate: 'Ablaufdatum',
        DateOfParticipation: 'Teilnahmedatum',
        StampsCollected: 'Gesammelte Stempel',
        CompletedDate: 'Abschlussdatum',
        RewardsAchieved: 'Erreichte Belohnungen',

        Active: 'Aktiv',
        Completed: 'Abgeschlossen',
        Expired: 'Abgelaufen'
      },

      IssueStampsModal: {
        MakerCheckerSuccessMessage: 'Stempelausgabeantrag zur Genehmigung eingereicht',
        SuccessMessage: 'Stempel erfolgreich ausgestellt!',
        ErrorMessage: 'Fehler beim Ausstellen der Stempel',
        IssueStampsButton: 'Stempel ausstellen',
        Title: 'Stempel ausstellen an',
        OkText: 'Stempel ausstellen',
        HowManyStamps: 'Wie viele Stempel?',
        ReasonForIssuance: 'Grund für die Ausstellung'
      },

      IssueRewardModal: {
        RewardIssuedSuccessfully: 'Belohnung erfolgreich ausgestellt!',
        ErrorIssueReward: 'Fehler bei der Belohnungsausgabe',
        IssueRewardTitle: 'Belohnungen ausstellen',
        IssueRewardOkText: 'Belohnung ausstellen',
        IssueRewardButton: 'Belohnung ausstellen',
        ReasonForAdjustment: 'Grund für die Anpassung'
      },

      AddRemovePointsModal: {
        PointsUpdatedSuccessfully: 'Punkte erfolgreich aktualisiert!',
        ErrorUpdatingPoints: 'Fehler beim Aktualisieren der Punkte',
        AddOrRemovePointsButton: 'Punkte hinzufügen/entfernen',
        AdjustProgressCampaignPoints: 'Fortschrittskampagnenpunkte anpassen',
        OkText: 'Punkte anpassen',
        HowManyPointsToAddOrRemove: 'Wie viele Punkte hinzufügen/entfernen?',
        ReasonForAdjustment: 'Grund für die Anpassung'
      }
    },

    CustomerStamps: {
      All: 'Alle',
      Active: 'Aktiv',
      Inactive: 'Inaktiv',
      Name: 'Name',
      Status: 'Status',
      Started: 'Begonnen',
      Ended: 'Beendet',
      ID: 'AUSWEIS',
      SearchPlaceholder: 'Finden Sie eine Kampagne mit Namen',
      EnrollCampaignModal: {
        SuccessMessage: 'Kampagne eingeschrieben erfolgreich!',
        ErrorMessage: 'Die Registrierung der Kampagne ist fehlgeschlagen.',
        CampaignIDValidationMessage: 'Bitte geben Sie eine Kampagne an',
        FullNameDefault: 'Aktueller Kunde',
        ManualEnrollButton: 'Manuelle Registrierung',
        Title: 'Einschreiben',
        OkText: 'Kunden anmelden',
        CancelText: 'Stornieren'
      },
      CampaignSelectField: {
        Label: 'Kampagne auswählen',
        Edit: 'Bearbeiten',
        Add: 'Hinzufügen',
        Campaign: 'Kampagne'
      },
      CampaignSelectModal: {
        Title: 'Wählen Sie eine Kampagne aus',
        CancelText: 'Stornieren',
        OkText: 'Kampagne hinzufügen',
        SearchPlaceholder: 'Suchen Sie eine Kampagne nach Name, Typ oder Händler',
        Name: 'Name',
        ID: 'AUSWEIS',
        Status: 'Status',
        Tags: 'Tags',
        StartDate: 'Startdatum',
        EndDate: 'Enddatum',

        Active: 'Aktiv',
        Approved: 'Genehmigt'
      }
    },

    CustomerGames: {
      Name: 'Name',
      ID: 'AUSWEIS',
      Status: 'Status',
      GameType: 'Spieltyp',
      TriesRedeemed: 'Versuche eingelöst',
      Started: 'Begonnen',
      Ended: 'Beendet',
      SearchPlaceholder: 'Finden Sie eine Kampagne mit Namen',
      SorrySomethingWentWrong: 'Entschuldigung, etwas ist schief gelaufen',
      Tabs: {
        All: 'Alle',
        Active: 'Aktiv',
        Approved: 'Genehmigt',
        Inactive: 'Inaktiv',
        Ended: 'Beendet'
      }
    }
  }
};
